import { Trash2, Plus, Phone, Mail, Globe } from "lucide-react";

const OTHER_TYPES = ["viber", "instagram", "facebook"];
const OTHER_LABELS = { viber: "Viber", instagram: "Instagram", facebook: "Facebook" };
const isOther = (t) => OTHER_TYPES.includes(t) || t === "whatsapp";
const inputCls = "flex-1 h-10 px-3 rounded-lg bg-muted text-sm outline-none focus:ring-2 ring-primary";

// Phones / email / website as dedicated fields, everything else as a free list; all stored in `contacts`
export const ContactFields = ({ contacts = [], onChange }) => {
  const byType = (t) => contacts.filter((c) => c.type === t);
  const setType = (t, values) => onChange([...contacts.filter((c) => c.type !== t), ...values.map((value) => ({ type: t, value }))]);
  const phones = byType("phone").map((c) => c.value);
  const shownPhones = phones.length ? phones : [""];
  const others = contacts.filter((c) => isOther(c.type)).map((c) => (c.type === "whatsapp" ? { ...c, type: "viber" } : c));
  const setOthers = (list) => onChange([...contacts.filter((c) => !isOther(c.type)), ...list]);

  return (
    <div className="rounded-xl border border-border p-3 space-y-3" data-testid="biz-contact-fields">
      <h4 className="font-bold text-sm text-slate-800">Στοιχεία επικοινωνίας</h4>
      <div>
        <label className="flex items-center gap-1.5 text-sm font-semibold mb-1.5"><Phone size={14} /> Τηλέφωνα</label>
        <div className="space-y-2">
          {shownPhones.map((p, i) => (
            <div key={i} className="flex gap-2">
              <input value={p} placeholder="π.χ. 6981234567" data-testid={`biz-phone-input-${i}`} className={inputCls}
                onChange={(e) => { const n = [...shownPhones]; n[i] = e.target.value; setType("phone", n); }} />
              <button type="button" onClick={() => setType("phone", shownPhones.filter((_, idx) => idx !== i))} className="h-10 w-10 grid place-items-center rounded-lg hover:bg-muted text-destructive"><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
        <button type="button" onClick={() => setType("phone", [...shownPhones, ""])} data-testid="biz-add-phone-btn" className="mt-2 text-sm font-semibold text-primary inline-flex items-center gap-1"><Plus size={14} /> Προσθήκη τηλεφώνου</button>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        <div>
          <label className="flex items-center gap-1.5 text-sm font-semibold mb-1.5"><Mail size={14} /> Email</label>
          <input type="email" value={byType("email")[0]?.value || ""} data-testid="biz-email-input" className={`${inputCls} w-full`}
            onChange={(e) => setType("email", e.target.value ? [e.target.value] : [])} />
        </div>
        <div>
          <label className="flex items-center gap-1.5 text-sm font-semibold mb-1.5"><Globe size={14} /> Ιστοσελίδα</label>
          <input value={byType("website")[0]?.value || ""} data-testid="biz-website-input" className={`${inputCls} w-full`}
            onChange={(e) => setType("website", e.target.value ? [e.target.value] : [])} />
        </div>
      </div>
      <div>
        <label className="text-sm font-semibold">Άλλα (Viber, Instagram, Facebook)</label>
        <div className="space-y-2 mt-1.5">
          {others.map((c, i) => (
            <div key={i} className="flex gap-2">
              <select value={c.type} onChange={(e) => setOthers(others.map((o, idx) => (idx === i ? { ...o, type: e.target.value } : o)))} className="h-10 px-2 rounded-lg bg-muted text-sm">
                {OTHER_TYPES.map((t) => <option key={t} value={t}>{OTHER_LABELS[t]}</option>)}
              </select>
              <input value={c.value} onChange={(e) => setOthers(others.map((o, idx) => (idx === i ? { ...o, value: e.target.value } : o)))} className={inputCls} />
              <button type="button" onClick={() => setOthers(others.filter((_, idx) => idx !== i))} className="h-10 w-10 grid place-items-center rounded-lg hover:bg-muted text-destructive"><Trash2 size={15} /></button>
            </div>
          ))}
        </div>
        <button type="button" onClick={() => setOthers([...others, { type: "viber", value: "" }])} data-testid="biz-add-other-contact-btn" className="mt-2 text-sm font-semibold text-primary inline-flex items-center gap-1"><Plus size={14} /> Προσθήκη</button>
      </div>
    </div>
  );
};
